import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';
import { useMutation, useApolloClient } from '@apollo/client';
import useRandomId from 'hooks/useRandomId';
import CtaLink from 'components/essentials/Cta/CtaLink';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import { getTempUserIdCookie } from 'commons/localStorage';
import CtaButton from 'components/essentials/Cta/CtaButton';
import { SIGNUP, RESET_PASSWORD } from '@/graphql/mutations';
import { GET_CART } from '@/graphql/queries';
import getZipcode from 'commons/getZipcode';
import { logError } from 'commons/logger';
import IconClose from 'components/icons/iconClose';
import { sendAnalyticsIdentifyEvent } from 'commons/analytics';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import { INVALID_NAME_CHARACTERS_REGEX, EMAIL_REGEX } from 'commons/constants';
import useSetAuthTokenAndUser from 'data-hooks/useUserData/useSetAuthTokenAndUser';
const initCaps = str => str && str[0].toUpperCase() + str.slice(1);
const IconTick = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g stroke="none" strokeWidth="1.25" fill="none" fillRule="evenodd"><g className="tick-stroke" transform="translate(0.000000, 1.000000)"><polyline points="0 3.6732398 3.4439402 7 11 0" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={11} height={9} viewBox="0 0 11 9" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const CreatePassword = t0 => {
  const $ = _c(135);
  const {
    mode: t1,
    state,
    actions,
    match,
    history
  } = t0;
  const mode = t1 === undefined ? "signup" : t1;
  const client = useApolloClient();
  const [formError, setFormError] = useState(null);
  const [showResetPassword, setShowResetPassword] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [firstNameValidations, setFirstNameValidations] = useState(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {};
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const [lastNameValidations, setLastNameValidations] = useState(t3);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {};
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const [nameErrorMsgs, setNameErrorMsgs] = useState(t4);
  const [emailError, setEmailError] = useState(false);
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {};
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const [passwordValidations, setPasswordValidations] = useState(t5);
  const passwordInfoId = useRandomId("CreatePassword__info");
  const currentPage = useUserCurrentPageType();
  let t6;
  if ($[4] !== actions) {
    t6 = evt => {
      actions.onPasswordChange(evt);
      const {
        value
      } = evt.target;
      if (value) {
        setPasswordValidations({
          charLen: value.length >= 6,
          hasLower: /[a-z]/.test(value),
          hasUpper: /[A-Z]/.test(value),
          hasNumber: /[0-9]/.test(value)
        });
      } else {
        setPasswordValidations({});
      }
    };
    $[4] = actions;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const onPasswordChange = t6;
  let t7;
  if ($[6] !== actions) {
    t7 = evt_0 => {
      actions.onFirstNameChange(evt_0);
      const value_0 = evt_0.target.value?.length > 0 ? evt_0.target.value.trim() : "";
      setFirstNameValidations({
        isTouched: true,
        isRequired: !value_0,
        minLength: value_0.length < 2,
        hasInvalidCharacters: INVALID_NAME_CHARACTERS_REGEX.test(value_0)
      });
    };
    $[6] = actions;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const onFirstNameChange = t7;
  let t8;
  if ($[8] !== actions) {
    t8 = evt_1 => {
      actions.onLastNameChange(evt_1);
      const value_1 = evt_1.target.value?.length > 0 ? evt_1.target.value.trim() : "";
      setLastNameValidations({
        isTouched: true,
        isRequired: !value_1,
        minLength: value_1.length < 2,
        hasInvalidCharacters: INVALID_NAME_CHARACTERS_REGEX.test(value_1)
      });
    };
    $[8] = actions;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const onLastNameChange = t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = evt_2 => {
      if (!EMAIL_REGEX.test(evt_2.target.value)) {
        setEmailError(true);
        return;
      }
      setEmailError(false);
    };
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const checkEmailInput = t9;
  const setAuthTokenAndUser = useSetAuthTokenAndUser();
  let t10;
  if ($[11] !== actions || $[12] !== client || $[13] !== currentPage || $[14] !== setAuthTokenAndUser) {
    t10 = {
      onCompleted: async data => {
        const {
          signup
        } = data;
        if (!signup || signup.errors) {
          setFormError(get(signup, "errors.0.message", "Unable to sign up please try again"));
        }
        if (signup.user) {
          const {
            access_token,
            refresh_token,
            email,
            id,
            last_name,
            first_name,
            group_id,
            is_designer,
            user_discount
          } = signup.user;
          await setAuthTokenAndUser({
            access_token,
            email,
            first_name,
            group_id,
            id,
            is_designer,
            is_impersonate: false,
            last_name,
            refresh_token,
            user_discount
          });
          client.query({
            query: GET_CART,
            variables: {
              zipCode: getZipcode()
            },
            fetchPolicy: "network-only"
          }).catch(_temp);
          actions.onSignUp(signup.user);
          const heapData = {
            userid: signup?.user?.id?.toString(),
            event: "Create Account",
            properties: "Website"
          };
          avo.emailAcquired({
            userId_: heapData.userid.toString(),
            email,
            location: currentPage,
            optedInMarketing: true,
            backendEmail: email,
            component: avo.Component.ACCOUNT_CREATION,
            talkativeCustomerId: ""
          });
          avo.accountCreated({
            userId_: heapData.userid.toString(),
            location: currentPage
          });
          sendAnalyticsIdentifyEvent(heapData.userid, {
            first_name,
            last_name,
            email
          });
        }
      }
    };
    $[11] = actions;
    $[12] = client;
    $[13] = currentPage;
    $[14] = setAuthTokenAndUser;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const [signUp, t11] = useMutation(SIGNUP, t10);
  const {
    loading: signUpLoading
  } = t11;
  let t12;
  if ($[16] !== actions || $[17] !== history) {
    t12 = {
      onCompleted: async data_0 => {
        if (data_0 && data_0.resetPassword) {
          if (data_0.resetPassword.success === true) {
            actions.onForgotPasswordSuccess();
            history.push("/sign-in");
          } else {
            setFormError(data_0.resetPassword.message);
            if (data_0.resetPassword.message?.includes("20007")) {
              setShowResetPassword(true);
            }
          }
        } else {
          setFormError("Unable to reset password.");
        }
      }
    };
    $[16] = actions;
    $[17] = history;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const [resetPassword, t13] = useMutation(RESET_PASSWORD, t12);
  const {
    loading: resetPasswordLoading
  } = t13;
  let t14;
  if ($[19] !== firstNameValidations.isRequired || $[20] !== firstNameValidations.isTouched || $[21] !== firstNameValidations.minLength || $[22] !== lastNameValidations.isRequired || $[23] !== lastNameValidations.isTouched || $[24] !== lastNameValidations.minLength || $[25] !== passwordValidations.charLen || $[26] !== passwordValidations.hasLower || $[27] !== passwordValidations.hasNumber || $[28] !== passwordValidations.hasUpper || $[29] !== signUp || $[30] !== state.email || $[31] !== state.first_name || $[32] !== state.last_name || $[33] !== state.password) {
    t14 = async () => {
      if (!firstNameValidations.isTouched || firstNameValidations.isRequired || firstNameValidations.minLength) {
        setFormError("First name is invalid");
        return;
      }
      if (!lastNameValidations.isTouched || lastNameValidations.isRequired || lastNameValidations.minLength) {
        setFormError("Last name is invalid");
        return;
      }
      if (!(passwordValidations.charLen && passwordValidations.hasLower && passwordValidations.hasUpper && passwordValidations.hasNumber)) {
        setFormError("Password is invalid");
        return;
      }
      await signUp({
        variables: {
          email: state.email.trim(),
          password: state.password,
          first_name: initCaps(state.first_name),
          last_name: initCaps(state.last_name),
          tempUserId: getTempUserIdCookie()
        }
      });
    };
    $[19] = firstNameValidations.isRequired;
    $[20] = firstNameValidations.isTouched;
    $[21] = firstNameValidations.minLength;
    $[22] = lastNameValidations.isRequired;
    $[23] = lastNameValidations.isTouched;
    $[24] = lastNameValidations.minLength;
    $[25] = passwordValidations.charLen;
    $[26] = passwordValidations.hasLower;
    $[27] = passwordValidations.hasNumber;
    $[28] = passwordValidations.hasUpper;
    $[29] = signUp;
    $[30] = state.email;
    $[31] = state.first_name;
    $[32] = state.last_name;
    $[33] = state.password;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  const doSignUp = t14;
  let t15;
  if ($[35] !== match.params.reset_token || $[36] !== resetPassword || $[37] !== state.password) {
    t15 = async () => {
      await resetPassword({
        variables: {
          new_password: state.password,
          confirm_new_password: state.password,
          token: match.params.reset_token
        }
      });
    };
    $[35] = match.params.reset_token;
    $[36] = resetPassword;
    $[37] = state.password;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  const doResetPassword = t15;
  let t16;
  if ($[39] !== doResetPassword || $[40] !== doSignUp || $[41] !== mode) {
    t16 = evt_3 => {
      evt_3.preventDefault();
      evt_3.stopPropagation();
      if (mode === "signup") {
        doSignUp();
      } else {
        doResetPassword();
      }
      return false;
    };
    $[39] = doResetPassword;
    $[40] = doSignUp;
    $[41] = mode;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  const onSubmit = t16;
  let t17;
  if ($[43] !== firstNameValidations.hasInvalidCharacters || $[44] !== firstNameValidations.isRequired || $[45] !== firstNameValidations.isTouched || $[46] !== firstNameValidations.minLength || $[47] !== lastNameValidations.hasInvalidCharacters || $[48] !== lastNameValidations.isRequired || $[49] !== lastNameValidations.isTouched || $[50] !== lastNameValidations.minLength) {
    t17 = () => {
      let firstNameErrorMsg = "";
      let lastNameErrorMsg = "";
      if (firstNameValidations.isTouched) {
        firstNameErrorMsg = firstNameValidations.isRequired ? "First name is required" : firstNameValidations.minLength ? "Min. 2 chars are required" : firstNameValidations.hasInvalidCharacters ? "Please remove invalid characters from name" : null;
      }
      if (lastNameValidations.isTouched) {
        lastNameErrorMsg = lastNameValidations.isRequired ? "Last name is required" : lastNameValidations.minLength ? "Min. 2 chars are required" : lastNameValidations.hasInvalidCharacters ? "Please remove invalid characters from name" : null;
      }
      setNameErrorMsgs({
        firstNameErrorMsg,
        lastNameErrorMsg
      });
    };
    $[43] = firstNameValidations.hasInvalidCharacters;
    $[44] = firstNameValidations.isRequired;
    $[45] = firstNameValidations.isTouched;
    $[46] = firstNameValidations.minLength;
    $[47] = lastNameValidations.hasInvalidCharacters;
    $[48] = lastNameValidations.isRequired;
    $[49] = lastNameValidations.isTouched;
    $[50] = lastNameValidations.minLength;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  let t18;
  if ($[52] !== firstNameValidations || $[53] !== lastNameValidations) {
    t18 = [firstNameValidations, lastNameValidations];
    $[52] = firstNameValidations;
    $[53] = lastNameValidations;
    $[54] = t18;
  } else {
    t18 = $[54];
  }
  useEffect(t17, t18);
  const t19 = mode === "forgot-password" ? " new " : "";
  let t20;
  if ($[55] !== t19) {
    t20 = <div className="text-xl font-bold">Create a {t19} password</div>;
    $[55] = t19;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  let t21;
  if ($[57] !== actions || $[58] !== emailError || $[59] !== mode || $[60] !== nameErrorMsgs || $[61] !== onFirstNameChange || $[62] !== onLastNameChange || $[63] !== state.email || $[64] !== state.first_name || $[65] !== state.last_name || $[66] !== state.showEmailError) {
    t21 = mode === "signup" && <><LabeledTextInput name="email" value={state.email.trim()} label="Email address" autoComplete="username" autoFocus={!state.email} onChange={evt_4 => {
        setEmailError(false);
        actions.onEmailChange(evt_4);
      }} onBlur={checkEmailInput} errorMessage={state.showEmailError || emailError ? "Email address is invalid" : null} /><LabeledTextInput name="first_name" label="First name" value={state.first_name} autoFocus={!!state.email} autoComplete="given-name" onChange={onFirstNameChange} errorMessage={nameErrorMsgs.firstNameErrorMsg || ""} /><LabeledTextInput name="last_name" label="Last name" value={state.last_name} autoComplete="family-name" onChange={onLastNameChange} errorMessage={nameErrorMsgs.lastNameErrorMsg || ""} /></>;
    $[57] = actions;
    $[58] = emailError;
    $[59] = mode;
    $[60] = nameErrorMsgs;
    $[61] = onFirstNameChange;
    $[62] = onLastNameChange;
    $[63] = state.email;
    $[64] = state.first_name;
    $[65] = state.last_name;
    $[66] = state.showEmailError;
    $[67] = t21;
  } else {
    t21 = $[67];
  }
  let t22;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="pb-[5px]">Your password must contain at least</div>;
    $[68] = t22;
  } else {
    t22 = $[68];
  }
  const t23 = passwordValidations.charLen === true;
  const t24 = passwordValidations.charLen === false;
  let t25;
  if ($[69] !== t23 || $[70] !== t24) {
    t25 = cx("pb-[3px] flex items-center [&_svg_path]:fill-gray [&_svg_g.tick-stroke]:stroke-[#424242]", {
      "text-brand [&_svg_path]:!fill-brand [&_svg_g.tick-stroke]:!stroke-[#107c8c]": t23,
      "text-red [&_svg_path]:!fill-red [&_svg_g.tick-stroke]:!stroke-[#b85455]": t24
    });
    $[69] = t23;
    $[70] = t24;
    $[71] = t25;
  } else {
    t25 = $[71];
  }
  let t26;
  if ($[72] !== passwordValidations.charLen) {
    t26 = passwordValidations.charLen ? <IconTick className="mr-1.5" /> : <IconClose width={8} height={9} className="mr-2" />;
    $[72] = passwordValidations.charLen;
    $[73] = t26;
  } else {
    t26 = $[73];
  }
  let t27;
  if ($[74] !== t25 || $[75] !== t26) {
    t27 = <div className={t25}>{t26}6 characters</div>;
    $[74] = t25;
    $[75] = t26;
    $[76] = t27;
  } else {
    t27 = $[76];
  }
  const t28 = passwordValidations.hasUpper === true;
  const t29 = passwordValidations.hasUpper === false;
  let t30;
  if ($[77] !== t28 || $[78] !== t29) {
    t30 = cx("pb-[3px] flex items-center [&_svg_path]:fill-gray [&_svg_g.tick-stroke]:stroke-[#424242]", {
      "text-brand [&_svg_path]:!fill-brand [&_svg_g.tick-stroke]:!stroke-[#107c8c]": t28,
      "text-red [&_svg_path]:!fill-red [&_svg_g.tick-stroke]:!stroke-[#b85455]": t29
    });
    $[77] = t28;
    $[78] = t29;
    $[79] = t30;
  } else {
    t30 = $[79];
  }
  let t31;
  if ($[80] !== passwordValidations.hasUpper) {
    t31 = passwordValidations.hasUpper ? <IconTick className="mr-1.5" /> : <IconClose width={8} height={9} className="mr-2" />;
    $[80] = passwordValidations.hasUpper;
    $[81] = t31;
  } else {
    t31 = $[81];
  }
  let t32;
  if ($[82] !== t30 || $[83] !== t31) {
    t32 = <div className={t30}>{t31}1 uppercase letter</div>;
    $[82] = t30;
    $[83] = t31;
    $[84] = t32;
  } else {
    t32 = $[84];
  }
  const t33 = passwordValidations.hasLower === true;
  const t34 = passwordValidations.hasLower === false;
  let t35;
  if ($[85] !== t33 || $[86] !== t34) {
    t35 = cx("pb-[3px] flex items-center [&_svg_path]:fill-gray [&_svg_g.tick-stroke]:stroke-[#424242]", {
      "text-brand [&_svg_path]:!fill-brand [&_svg_g.tick-stroke]:!stroke-[#107c8c]": t33,
      "text-red [&_svg_path]:!fill-red [&_svg_g.tick-stroke]:!stroke-[#b85455]": t34
    });
    $[85] = t33;
    $[86] = t34;
    $[87] = t35;
  } else {
    t35 = $[87];
  }
  let t36;
  if ($[88] !== passwordValidations.hasLower) {
    t36 = passwordValidations.hasLower ? <IconTick className="mr-1.5" /> : <IconClose width={8} height={9} className="mr-2" />;
    $[88] = passwordValidations.hasLower;
    $[89] = t36;
  } else {
    t36 = $[89];
  }
  let t37;
  if ($[90] !== t35 || $[91] !== t36) {
    t37 = <div className={t35}>{t36}1 lowercase letter</div>;
    $[90] = t35;
    $[91] = t36;
    $[92] = t37;
  } else {
    t37 = $[92];
  }
  const t38 = passwordValidations.hasNumber === true;
  const t39 = passwordValidations.hasNumber === false;
  let t40;
  if ($[93] !== t38 || $[94] !== t39) {
    t40 = cx("pb-[3px] flex items-center [&_svg_path]:fill-gray [&_svg_g.tick-stroke]:stroke-[#424242]", {
      "text-brand [&_svg_path]:!fill-brand [&_svg_g.tick-stroke]:!stroke-[#107c8c]": t38,
      "text-red [&_svg_path]:!fill-red [&_svg_g.tick-stroke]:!stroke-[#b85455]": t39
    });
    $[93] = t38;
    $[94] = t39;
    $[95] = t40;
  } else {
    t40 = $[95];
  }
  let t41;
  if ($[96] !== passwordValidations.hasNumber) {
    t41 = passwordValidations.hasNumber ? <IconTick className="mr-1.5" /> : <IconClose width={8} height={9} className="mr-2" />;
    $[96] = passwordValidations.hasNumber;
    $[97] = t41;
  } else {
    t41 = $[97];
  }
  let t42;
  if ($[98] !== t40 || $[99] !== t41) {
    t42 = <div className={t40}>{t41}1 number</div>;
    $[98] = t40;
    $[99] = t41;
    $[100] = t42;
  } else {
    t42 = $[100];
  }
  let t43;
  if ($[101] !== passwordInfoId || $[102] !== t27 || $[103] !== t32 || $[104] !== t37 || $[105] !== t42) {
    t43 = <div className="text-xs mb-2" id={passwordInfoId}>{t22}{t27}{t32}{t37}{t42}</div>;
    $[101] = passwordInfoId;
    $[102] = t27;
    $[103] = t32;
    $[104] = t37;
    $[105] = t42;
    $[106] = t43;
  } else {
    t43 = $[106];
  }
  let t44;
  if ($[107] !== onPasswordChange || $[108] !== passwordInfoId || $[109] !== state.password) {
    t44 = <LabeledTextInput aria-describedby={passwordInfoId} name="password" type="password" label="Password" value={state.password} autoComplete="current-password" onChange={onPasswordChange} />;
    $[107] = onPasswordChange;
    $[108] = passwordInfoId;
    $[109] = state.password;
    $[110] = t44;
  } else {
    t44 = $[110];
  }
  let t45;
  if ($[111] !== t43 || $[112] !== t44) {
    t45 = <div>{t43}{t44}</div>;
    $[111] = t43;
    $[112] = t44;
    $[113] = t45;
  } else {
    t45 = $[113];
  }
  const t46 = signUpLoading || resetPasswordLoading;
  const t47 = signUpLoading || resetPasswordLoading;
  const t48 = mode === "signup" ? "Create" : "Continue";
  let t49;
  if ($[114] !== t46 || $[115] !== t47 || $[116] !== t48) {
    t49 = <CtaButton type="submit" color="black" styling="solid-button" data-xc="signin-button" disabled={t46} block={true} isLoading={t47}>{t48}</CtaButton>;
    $[114] = t46;
    $[115] = t47;
    $[116] = t48;
    $[117] = t49;
  } else {
    t49 = $[117];
  }
  let t50;
  if ($[118] !== actions.showResetPassword || $[119] !== formError || $[120] !== showResetPassword) {
    t50 = formError && <><div className="text-sm font-bold text-red mx-0 my-[.325rem] text-center">{formError}</div>{showResetPassword && <div className="text-sm text-center"><CtaButton onClick={actions.showResetPassword} hasArrow={false} styling="link" color="brand" size="sm">Reset Password</CtaButton></div>}</>;
    $[118] = actions.showResetPassword;
    $[119] = formError;
    $[120] = showResetPassword;
    $[121] = t50;
  } else {
    t50 = $[121];
  }
  let t51;
  if ($[122] !== onSubmit || $[123] !== t21 || $[124] !== t45 || $[125] !== t49 || $[126] !== t50) {
    t51 = <form method="POST" onSubmit={onSubmit}>{t21}{t45}{t49}{t50}</form>;
    $[122] = onSubmit;
    $[123] = t21;
    $[124] = t45;
    $[125] = t49;
    $[126] = t50;
    $[127] = t51;
  } else {
    t51 = $[127];
  }
  let t52;
  if ($[128] !== actions.onLoginClick || $[129] !== mode) {
    t52 = mode === "signup" && <><div className="text-xs text-center mt-4 mx-0 mb-6 [&_a]:px-1 [&_a]:py-0">By creating an account, you are agreeing to our<CtaLink to="/privacy-policy/" color="brand" hasArrow={false} size="xs">Privacy Policy</CtaLink>{"&"}<CtaLink to="/terms-of-use/" color="brand" hasArrow={false} size="xs" className="!pr-0">Terms of Use</CtaLink>. You also agree to receive exclusive sales and design inspiration via email; you can unsubscribe at any time.</div><div className="text-sm text-center">Already have an account?  <CtaButton onClick={actions.onLoginClick} color="brand" styling="link" hasArrow={false} size="sm">Log in</CtaButton></div></>;
    $[128] = actions.onLoginClick;
    $[129] = mode;
    $[130] = t52;
  } else {
    t52 = $[130];
  }
  let t53;
  if ($[131] !== t20 || $[132] !== t51 || $[133] !== t52) {
    t53 = <div className="text-gray"><div className="consumer-create-password__content">{t20}{t51}{t52}</div></div>;
    $[131] = t20;
    $[132] = t51;
    $[133] = t52;
    $[134] = t53;
  } else {
    t53 = $[134];
  }
  return t53;
};
CreatePassword.propTypes = {
  mode: PropTypes.oneOf(['signup', 'forgot-password']),
  history: PropTypes.shape({
    goBack: PropTypes.func,
    push: PropTypes.func
  }),
  match: PropTypes.object,
  state: PropTypes.object,
  actions: PropTypes.shape({
    onForgotPasswordSuccess: PropTypes.func,
    showResetPassword: PropTypes.func,
    onFirstNameChange: PropTypes.func,
    onLastNameChange: PropTypes.func,
    onPasswordChange: PropTypes.func,
    onEmailChange: PropTypes.func,
    onLoginClick: PropTypes.func,
    onSignUp: PropTypes.func
  })
};
export default withRouter(CreatePassword);
function _temp(err) {
  logError(err, "Failed to fetch cart on signup");
}